import {Injectable} from '@angular/core';
import {IndividualDetailViewModel} from '../../customer/models/views/individual-detail-view.model';
import {OrganizationDetailViewModel} from '../../customer/models/views/organization-detail-view.model';
import {CommonDetailViewModel} from '../../customer/models/views/common-detail-view.model';
import {CustomerCorrespondenceModel} from '../models/correspondence.model';
import { CorrespondenceSendOptionsModel } from '../../shared/models/output/correspondence-send-options.model';

@Injectable()
export class CustomerCorrespondenceService {
    public getFlattenedIndividualCustomerDetailModel(model: IndividualDetailViewModel): CustomerCorrespondenceModel {
        var response = new CustomerCorrespondenceModel();
        response.firstName = model.nameDetail.firstName;
        response.lastName = model.nameDetail.lastName;
        response.address1Line1 = model.addresses[0].addressLine1;
        response.address1Line2 = model.addresses[0].addressLine2;
        response.address1City = model.addresses[0].city;
        response.address1State = model.addresses[0].postalDeliveryCode;
        response.address1Zip = model.addresses[0].postalZipCode;
        return response;
    }
    public getFlattenedOrganizationCustomerDetailModel(model: OrganizationDetailViewModel): CustomerCorrespondenceModel {
        var response = new CustomerCorrespondenceModel();
        response.organizationName = model.nameDetail.organizationName;
        return response;
    }

    getSendOptions(customerDetail: CommonDetailViewModel): CorrespondenceSendOptionsModel {
        const retVal = new CorrespondenceSendOptionsModel();

        // get whether or not this customer has an email address
        retVal.allowEmail = customerDetail && customerDetail.contacts
            && customerDetail.contacts.some(c => (c.contactMethodTypeId == 5 || c.contactMethodTypeId == 6) && c.isCorrespondenceEnabled);

        // get whether or not this customer has a physical address
        retVal.allowUsps = customerDetail && customerDetail.addresses
            && customerDetail.addresses.length > 0;

        // if email is allowed, however an address is noted as the preferred contact method, then disable email
        if (retVal.allowEmail
            && retVal.allowUsps
            && customerDetail
            && (customerDetail.addresses
                // check addresses array, plus physical and mailing as the array seems to return partially hydrated sometimes
                && customerDetail.addresses.some(a => a.isPreferredContactMethod))
                || (customerDetail.physicalAddress && customerDetail.physicalAddress.isPreferredContactMethod)
                || (customerDetail.mailingAddress && customerDetail.mailingAddress.isPreferredContactMethod)) {
            retVal.preferredUsps = true;
        }

        // if usps is allowed, however an email address is noted as the preferred contact method, then disable usps
        if (retVal.allowUsps
            && retVal.allowEmail
            && customerDetail && customerDetail.contacts
            && customerDetail.contacts.some(c => (c.contactMethodTypeId == 5 || c.contactMethodTypeId == 6) && c.isPreferredContactMethod && c.isCorrespondenceEnabled)) {
            retVal.preferredEmail = true;
        }

        return retVal;
    }

}
